/**
 * The study chat's conversation is kept only on this device (never synced to
 * the account) and is wiped when someone logs out, so the next person on a
 * shared computer can't read it.
 */

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
  at: number;
}

const KEY = 'studio.chat.v1';
const MAX_MESSAGES = 80;

export function loadChat(): ChatMessage[] {
  try {
    const raw = localStorage.getItem(KEY);
    const list = raw ? (JSON.parse(raw) as ChatMessage[]) : [];
    return Array.isArray(list) ? list.filter((m) => (m.role === 'user' || m.role === 'assistant') && typeof m.content === 'string') : [];
  } catch {
    return [];
  }
}

export function saveChat(messages: ChatMessage[]) {
  try {
    localStorage.setItem(KEY, JSON.stringify(messages.slice(-MAX_MESSAGES)));
  } catch {
    /* storage full or unavailable */
  }
}

export function clearChat() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
